import { render, staticRenderFns } from "./OrderFormSelectProduct.module.vue?vue&type=template&id=19db0520&scoped=true&"
import script from "./OrderFormSelectProduct.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormSelectProduct.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormSelectProduct.module.vue?vue&type=style&index=0&id=19db0520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db0520",
  null
  
)

export default component.exports